import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PrimaryHero from '../components/PrimaryHero';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

class Terms extends React.Component {

  static propTypes = {
    showRefreshing: PropTypes.func.isRequired,
    hideRefreshing: PropTypes.func.isRequired,
  };

  static getStylesheet() {
    return `
      @media (min-width: 993px) {
        div#wrapper-inner > div {
          position: relative;
          top: -75px;
          margin-bottom: -75px;
        }
      }
    `;
  }

  constructor(props) {
    super(props);

    this.style = {
      externalLink: {
        top: '-2px',
      },
    };
  }

  render() {
    const { showRefreshing, hideRefreshing } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            Terms of Service &ndash; Sprint Boards
          </title>

          <style type="text/css">
            {Terms.getStylesheet()}
          </style>
        </Helmet>

        <Header showRefreshing={showRefreshing} hideRefreshing={hideRefreshing} />

        <div id="wrapper">
          <PrimaryHero>
            <h1 className="h2 font-weight-normal mb-4">
              Terms of Service
            </h1>

            <p
              className="lead font-weight-light text-white mb-0"
            >
              These terms and conditions were last updated on March 16, 2025.
            </p>
          </PrimaryHero>

          <div id="wrapper-inner" className="w-100 bg-light px-lg-5 pb-4 pb-lg-5">
            <div className="container-fluid shadow-sm rounded bg-white py-4 py-lg-5">
              <div className="container">
                <h2 className="h3 mb-3">
                  Preamble
                </h2>

                <p>
                  Your use of this website ("service") is subject to the following terms and conditions ("terms").
                  We may update these terms from time to time and it is your own responsibility to check this page
                  regularly as the most recent terms take effect as soon as they are published. By continuing to use
                  this website, you are signifying your implied acceptance to these terms.
                </p>

                <p>
                  The headings do not form part of the terms and conditions in any way and are for your convenience
                  only.
                </p>

                <h2 className="h3 mb-3">
                  Liability
                </h2>

                <p>
                  This service comes with absolutely no warranties of any kind, including (without limitation to) the
                  implied warranties of merchantability and fitness for a particular purpose. Your use of this service
                  is at your sole risk and responsibility. We do not guarantee, represent or warrant that your use of
                  this service will be uninterrupted, secure, timely or error-free.
                </p>

                <p>
                  We will not be responsible for any losses or damages incurred to you or to any third party as a
                  result of your use of this service, even if we are aware or were made aware of the possibility of
                  such losses or damages.
                </p>

                <p>
                  If we are found to be liable to you for any loss or damage which arises out of or in connection with
                  these terms or your use of our service, our maximum aggregate liability to you shall not exceed
                  US$100.00 or the total amount you have paid to us in the last twelve months prior to the date of the
                  initial claim made against us.
                </p>

                <p>
                  The service may be modified or discontinued at any time without any notice to you. We may change
                  the way the service works in a way that adversely impacts you &ndash; for example, we may alter or
                  remove certain features. We also reserve the right to prevent you from using the service at any
                  time. Any reliance you place on the availability or timeliness of this service is at your own risk
                  and responsibility.
                </p>

                <h2 className="h3 mb-3">
                  Payments
                </h2>

                <p>
                  If you issue a chargeback against us, or cause a chargeback to be issued by the account holder as a
                  result of your negligence or willful misconduct, you agree to pay us on demand an administration
                  fee of US$75.00, or the equivalent in Barbados Dollars, for each chargeback plus the full amount in
                  dispute.
                </p>

                <p>
                  If you fail to pay for any outstanding debts or invoices within four weeks after their due date, we
                  reserve the right to pass this outstanding balance onto a debt collection agency for recovery
                  action. Upon which your outstanding debt will be with the appointed debt recovery agency and no
                  further late payments will be accepted by us to settle it.
                </p>

                <h2 className="h3 mb-3">
                  Indemnification
                </h2>

                <p>
                  You agree to indemnify, defend and hold harmless us and our parent, subsidiaries, affiliates,
                  partners, officers, directors, agents, contractors, licensors, service providers, subcontractors,
                  suppliers and employees, harmless from any and all claims or demands, including (without limitation
                  to) reasonable attorneys' fees, made by any third party due to or arising out of your breach of
                  these terms and conditions, or your violation of any law or the rights of a third party.
                </p>

                <p>
                  If you are using this service or making a purchase on behalf of a legal entity other than yourself
                  (such as the company or organisation of your place of work), you warrant that you are duly authorised
                  to bind that entity to these terms. You agree to bear full liability for any losses or damages to us
                  if the entity claims, or a court or arbitrator finds, that you did not have the appropriate authority
                  to bind the entity to these terms.
                </p>

                <h2 className="h3 mb-3">
                  Publishing Content
                </h2>

                <p>
                  We reserve the right, but not the obligation, to alter or remove any content or material published
                  on the service.
                </p>

                <p>
                  You are solely responsible for the content and material you publish on this service.
                  Any content or material you publish on this website may be seen by others: never publish anything
                  confidential, sensitive or personally-identifying, or any other content or material to which your
                  employer prohibits or ought to prohibit you from publishing or otherwise disclosing.
                </p>

                <p>
                  Any content or material you publish on this website must comply with all applicable laws. You must not
                  publish any content which is offensive, obscene, objectionable, immoral or illegal.
                </p>

                <h2 className="h3 mb-3">
                  Privacy Policy
                </h2>

                <p>
                  We conduct random audits of content published on our website, including content which has been
                  deleted, for compliance with the Online Safety Act (UK) and equivalent legislation. During an audit,
                  user content is visible to us in decrypted form. We store an internal record of each audit for
                  compliance purposes.
                </p>

                <p>
                  We ask for your name and email address when you create an account on our website. If you subscribe, or
                  update your name or email address on Sprint Boards while you are subscribed, we will share this
                  information with Stripe (our payment provider) so we can link your customer account on Sprint Boards
                  with your customer account on Stripe.
                </p>

                <p>
                  When you login, register, subscribe or otherwise interact with our website, we may collect your IP
                  address and user agent string to prevent and detect abuse ("audit log information"). One of the ways
                  in which we use your audit log information is to implement effective technical measures to prevent
                  abuse of special offers such as free trials, misuse of API rate limits and denial of service
                  attacks.
                </p>

                <p>
                  Like many websites, we use Google Analytics to collect anonymous information about how visitors are
                  using our website and where they are coming from. We do not collect information to personally identify
                  you and we do not allow Google Analytics to store your full IP address. Using Google Analytics helps
                  us to:
                </p>

                <ul>
                  <li className="mb-1">
                    understand what websites are referring visitors to us
                  </li>

                  <li className="mb-1">
                    discover what country our visitors are coming from
                  </li>

                  <li className="mb-1">
                    learn what pages visitors are accessing and when
                  </li>

                  <li className="mb-1">
                    identify what browser and operating system visitors use
                  </li>

                  <li>
                    analyse and identify website usage patterns
                  </li>
                </ul>

                <p>
                  You can prevent Google Analytics from collecting information from your visit by installing the Google
                  Analytics Opt-out Browser Add-on:

                  {' '}

                  <a
                    target="_blank"
                    rel="noreferrer nofollow noopener"
                    href="https://tools.google.com/dlpage/gaoptout"
                  >
                    https://tools.google.com/dlpage/gaoptout
                  </a>.
                </p>

                <p>
                  To learn more about how Google processes your information, please visit:

                  {' '}

                  <a
                    target="_blank"
                    rel="noreferrer nofollow noopener"
                    href="https://policies.google.com/technologies/partner-sites"
                  >
                    https://policies.google.com/technologies/partner-sites
                  </a>.
                </p>

                <p>
                  We may send you occasional service updates by email if we need to perform essential maintenance that
                  takes our service offline, or make changes to our website that may impact you or others. We will not
                  send you any marketing emails unless you opt in. You'll always have the right to opt out at any
                  time.
                </p>

                <p>
                  We will not pass on your details to any third party, except as permitted within these terms, unless
                  we are required to do so by law or if we believe in good faith it is necessary to do so to comply
                  with the law or to protect the life or property of ourselves or others.
                </p>

                <p>
                  Your information will be stored and processed by us and our suppliers for as long as reasonably
                  necessary to fulfill our service to you. You may send us a request to provide you with a copy of,
                  to update or remove your personal information, or any other information that personally identifies
                  you, at any time. There may be some circumstances where we cannot comply with your request: this may
                  happen if we are unable to verify your identity, are required by law to retain your information for a
                  longer period of time or are otherwise subject to a court or legal order.
                </p>

                <h2 className="h3 mb-3">
                  Backups
                </h2>

                <p>
                  We create and store weekly backups of our website and database as part of our internal disaster
                  recovery plans. Any information that you (or we) permanently delete may still exist in our backup
                  storage for up to five weeks &ndash; we retain each backup for four weeks.
                </p>

                <p>
                  These backups are for our own internal disaster recovery purposes only. You agree that we are under
                  no obligation to retain or use any backup to restore information you or your team may have
                  permanently deleted or otherwise altered, even if we are made aware of this. You must make your own
                  backup arrangements with regard to any information you or your team publishes on our service.
                </p>

                <h2 className="h3 mb-3">
                  Enforcement
                </h2>

                <p>
                  Any failure on us to exercise or enforce any term or condition within this agreement shall not in
                  any way constitute a waiver of such term or condition, or impact our ability to exercise or enforce
                  it at any time.
                </p>

                <p>
                  Nothing in these terms confers or intends to confer any rights on third parties. You and we expressly
                  exclude any rights of third parties who may otherwise be entitled to enforce the terms of this
                  agreement as if they were a party to it.
                </p>

                <p>
                  Both you and we agree that our relationship is one of independent contractors only. These terms
                  shall not be construed as creating a partnership, association, agency, employment or joint venture
                  between the parties.
                </p>

                <p>
                  Except for claims or causes of action relating to the copyright, design, trademark, trade
                  dress or patent rights of either party, both parties agree that any claim or cause of action
                  relating to, arising out of or in connection with these terms or any manner relating to the service,
                  must be commenced within one year after the cause of action arises, or such claim or cause of action
                  shall be forever barred.
                </p>

                <p>
                  These terms constitutes the entire agreement and understanding between you and us, and supersedes
                  any prior understanding, agreement or arrangement, whether made orally or in writing, between you
                  and us (including, without limitation to, any prior versions of these terms).
                </p>

                <h2 className="h3 mb-3">
                  Governing Law
                </h2>

                <p>
                  These terms shall be governed by and construed in accordance with the laws of Barbados
                  under the exclusive jurisdiction of the Barbadian Courts with no regard to differences in laws or
                  principles thereof.
                </p>

                <p>
                  If any term or condition is found to be unfair, unenforceable or illegal by a court of competent
                  jurisdiction, then that term or condition shall be severed as if it was never contained in the
                  agreement, and the remaining terms and conditions shall continue in full force and effect, and
                  continue to be fully binding and enforceable.
                </p>

                <h2 className="h3 mb-3">
                  Contacting Us
                </h2>

                <p>
                  You can reach us by using our online form

                  {' '}

                  <Link to="/support/create">
                    here
                  </Link>

                  {' '}

                  or by emailing

                  {' '}

                  <a href="mailto:support@sprintboards.io">
                    support@sprintboards.io
                  </a>.
                </p>

                <p className="mb-0">
                  <span className="font-weight-medium">
                    Sprint Boards
                  </span>

                  <br />

                  Level 1
                  <br />
                  One Welches
                  <br />
                  St. Thomas
                  <br />
                  Barbados
                </p>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </React.Fragment>
    );
  }

}

export default Terms;
